import {schema as Schema} from 'normalizr';

export const learningPathsAllSchemaEntity = new Schema.Entity('items', {}, {idAttribute: 'id'});
export const learningPathsAllSchema = new Schema.Array(learningPathsAllSchemaEntity);
